<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        :size="50"
        color="primary"
        indeterminate
      />
    </div>

    <div v-show="dataLoaded">
      <v-row class="my-0">
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-card
            ref="mainCard"
            class="base-card shadow pb-4 pl-4"
            :class="{
              'pr-4': !isVerticalScrollInTable,
              'pr-0': isVerticalScrollInTable
            }"
          >
            <v-data-table
              ref="table"
              class="base-table fixed-last-column shadow-for-last-column is-vertical-scroll elevation-0 mt-3"
              :class="{
                'shadow-last-column': isShadowForLastColumn
              }"
              :loading="tableLoading"
              :headers="tableHeaders"
              :items="commonWorkParent"
              :items-per-page="-1"
              loading-text="Загрузка"
              no-data-text="Нет данных"
              no-results-text="Не найдено"
              hide-default-footer
              fixed-header
              v-scroll.self="tableScroll"
            >
              <template v-slot:body.prepend="">
                <div
                  v-if="!tableLoading"
                  style="height: 1px"
                ></div>
              </template>

              <template v-slot:item.index="{ index }">
                {{ index + 1 }}
              </template>

              <template v-slot:item.userDepartment="{ item }">
                {{ getUserDepartmentInWork(item) }}
              </template>

              <template v-slot:item.work.commonWork.statementDate="{ item }">
                {{ getFormatStatementDate(item.work.commonWork.statementDate) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="table-icons">
                  <v-icon
                    v-if="
                      [
                        workStatusListName.Draft,
                        workStatusListName.Review,
                        workStatusListName.Revision,
                        workStatusListName.Accepted,
                        workStatusListName.Rejected
                      ].includes(workStatusList[item.work.commonWork?.status.id])
                    "
                    class="uikit-icon eye show-btn"
                    title="Открыть"
                    @click="show(item)"
                  />
                  <v-icon
                    v-if="
                      item.isCreator &&
                      [workStatusListName.Draft, workStatusListName.Revision].includes(
                        workStatusList[item.work.commonWork?.status.id]
                      )
                    "
                    class="uikit-icon edit-icon edit-btn"
                    title="Редактировать"
                    @click="edit(item)"
                  />
                  <v-icon
                    v-if="
                      item.isCreator &&
                      [workStatusListName.Draft].includes(workStatusList[item.work.commonWork?.status.id])
                    "
                    class="uikit-icon trash remove-btn"
                    title="Удалить"
                    @click="showRemoveConfirm(item)"
                  />
                  <v-icon
                    v-if="[workStatusListName.Review].includes(workStatusList[item.work.commonWork?.status.id])"
                    class="uikit-icon vector-left remove-btn"
                    title="Вернуть с рассмотрения"
                    @click="returnWork(item)"
                  />
                </div>
              </template>

              <template slot="no-data">
                <div>Таблица пуста</div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <Confirm
      :loading="removeLoading"
      :dialog="confirmDialog"
      message="Подтвердите удаление работы"
      @closeConfirmModal="confirmDialog = false"
      @confirm="remove"
    />
  </div>
</template>

<script>
import { commonWorkApi } from '@/api'
import { getFormatDate, getWorkTypeNameById } from '@/scripts'
import { cloneDeep } from 'lodash'
import { Filters } from '@/models'
import Confirm from '@/components/dialogs/Confirm.vue'
import { shadowForLastColumn } from '@/mixins/shadowForLastColumn'
import { workStatusList, workStatusListName } from '@/scripts/consts'
import { tableHeight } from '@/mixins/tableHeight'
import { mapGetters } from 'vuex'
import { isVerticalScrollInTable } from '@/mixins/isVerticalScrollInTable'

export default {
  name: 'AllWorks',

  computed: {
    ...mapGetters('filters', ['savedFilter']),
    ...mapGetters('user', ['userId']),

    workStatusListName() {
      return workStatusListName
    },

    workStatusList() {
      return workStatusList
    }
  },

  components: { Confirm },
  mixins: [shadowForLastColumn, tableHeight, isVerticalScrollInTable],

  metaInfo: {
    title: 'Научные работы'
  },

  props: {
    filtersProp: {
      type: Object
    },
    triggerSetTableHeight: {
      type: Boolean
    }
  },

  created() {
    this.setShowFilterFields()

    this.filters = new Filters(this.savedFilter('allWorks'))
    this.$emit('setExcludeTypes', this.filters.excludedType)

    this.getCommonWorkParent()
  },

  data: () => ({
    tableHeaders: [
      { text: '№', value: 'index', sortable: false, align: 'start' },
      { text: 'Статус', value: 'work.commonWork.status.name', sortable: false, align: 'start' },
      { text: 'Тип работы', value: 'work.commonWork.workType.name', sortable: false, align: 'start' },
      { text: 'Год', value: 'work.commonWork.year.year', sortable: false, align: 'start' },
      { text: 'Наименование работы', value: 'work.commonWork.workName', sortable: false, align: 'start' },
      { text: 'Подразделение', value: 'userDepartment', sortable: false, align: 'start' },
      { text: 'Наименование издания', value: 'work.magazine.name', sortable: false, align: 'start' },
      { text: 'Дата принятия', value: 'work.commonWork.statementDate', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '120px' }
    ],

    commonWorkParent: [],
    tableLoading: false,
    selectedItem: null,
    confirmDialog: false,
    dataLoaded: false,
    pageNumber: 0,
    lastPage: false,
    total: 0,
    errorLoad: false,
    filters: new Filters(),
    removeLoading: false,
    excludeTypes: [19]
  }),

  methods: {
    getFormatDate,
    setShowFilterFields() {
      this.$emit('setShowFilterFields', {
        isShowSearchString: true,
        isShowWorkTypeId: true,
        isShowStatusId: true,
        isShowYearId: true,
        isShowDepartmentList: false,
        isShowEmployeeId: false
      })
    },

    getFormatStatementDate(statementDate) {
      return statementDate ? getFormatDate(statementDate) + ' г.' : ''
    },

    async getCommonWorkParent() {
      if (this.errorLoad) return
      try {
        if (!this.lastPage) {
          this.tableLoading = true

          this.filters.setExcludedType(this.excludeTypes)

          const { content, last, totalElements } = await commonWorkApi.findAllForCurrentUser(
            this.pageNumber,
            this.filters.getForAPI()
          )
          if (this.pageNumber === 0) this.commonWorkParent = []
          this.lastPage = last
          this.total = totalElements
          this.pageNumber++

          content.length && content.forEach(obj => this.commonWorkParent.push(obj))
          this.checkHeightElementAndChangeIsVerticalScrollInTable()
          this.tableLoading = false
        }
      } catch (e) {
        console.log(e)
        if (e) {
          this.tableLoading = false
          this.showErrorMessage(e, 'Не удалось получить список работ')
          this.errorLoad = true
        } else this.tableLoading = true
      } finally {
        this.dataLoaded = true
      }
    },

    getUserDepartmentInWork(work) {
      return (
        work.work.commonWork.authors.find(author => author.employee?.user === this.userId)?.employeePosition?.department
          ?.name || '-'
      )
    },

    show(item) {
      this.$router.push('/works/' + getWorkTypeNameById(item.work.commonWork.workType.id) + '/show/' + item.work.id)
    },

    edit(item) {
      this.$router.push('/works/' + getWorkTypeNameById(item.work.commonWork.workType.id) + '/edit/' + item.work.id)
    },

    async returnWork(item) {
      try {
        await commonWorkApi.returnFromReview(item.work.commonWork?.id)
        item.work.commonWork.status = { id: 1, name: 'Черновик' }
        this.$toast.info('Успешно возвращено с рассмотрения')
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка возвращения с рассмотрения')
      }
    },

    showRemoveConfirm(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async remove() {
      try {
        this.removeLoading = true

        await commonWorkApi.remove(this.selectedItem.work.commonWork.id)
        const index = this.commonWorkParent.findIndex(
          el => el.work.commonWork.id === this.selectedItem.work.commonWork.id
        )
        this.commonWorkParent.splice(index, 1)
        this.$toast.info('Успешно удалено')
        this.confirmDialog = false
        this.selectedItem = null

        this.pageNumber--
        this.lastPage = false
        this.total = 0
        this.getCommonWorkParent()
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось удалить работу')
      } finally {
        this.removeLoading = false
      }
    },

    tableScroll(event) {
      const el = event.target
      if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading) {
        this.getCommonWorkParent()
      }
    }
  },

  watch: {
    dataLoaded() {
      this.setTableHeight()
    },

    triggerSetTableHeight() {
      this.setTableHeight()
    },

    filtersProp: {
      deep: true,
      async handler(val) {
        if (this.dataLoaded) {
          this.filters = cloneDeep(val)
          this.pageNumber = 0
          this.lastPage = false
          this.total = 0
          if (this.userId) {
            await this.getCommonWorkParent()
          }
        }
      }
    }
  }
}
</script>

<style scoped></style>
